import React, { Suspense } from "react";
import clsx from "clsx";
import { HvContainer } from "@hitachivantara/uikit-react-core";
import Loading from "components/layout/Loading";
import { LoadingProps } from "../Loading/Loading";
import useStyles from "./styles";

interface ContainerProps {
  hasTopMargin?: boolean;
  fullScreen?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  children: NonNullable<React.ReactNode>;
  className?: string;
  loadingProps?: LoadingProps;
  noHVContainer?: boolean;
}

const Container: React.FC<ContainerProps> = ({
  hasTopMargin = false,
  fullScreen = true,
  maxWidth = false,
  noHVContainer = false,
  children,
  className,
  loadingProps,
}) => {
  const classes = useStyles();
  const cookie = localStorage.getItem("cookiesAccept");

  return (
    <div
      className={clsx(className, classes.content, {
        [classes.topMargin]: hasTopMargin,
        [classes.fullHeight]: fullScreen,
        [classes.cookieBar]: !cookie,
        [classes.kpi]: !fullScreen,
      })}
    >
      <Suspense fallback={<Loading {...loadingProps} />}>
        {!noHVContainer && (
          <HvContainer maxWidth={maxWidth} className={clsx(classes.container)}>
            {children}
          </HvContainer>
        )}
        {noHVContainer && <>{children}</>}
      </Suspense>
    </div>
  );
};

export default Container;
